/**
 * PanelUser
 * @author Simpli CLI generator
 */
import {$, Resource, ResponseExclude, ResponseSerialize} from 'simpli-web-sdk'
import {Address} from '@/model/resource/Address'
import {UserType} from '@/model/resource/UserType'
import {PanelUserCollection} from '../collection/PanelUserCollection'
import {PanelUserFlags} from '@/model/resource/PanelUserFlags'
import {PanelUserInfo} from '@/model/resource/PanelUserInfo'
import {sha256} from 'js-sha256'
import {Env} from '@/helpers/Env'
import {InternationalRequest} from '@/helpers/InternationalRequest'
import {UserTypeEnum} from '@/enums/UserTypeEnum'
import {VisualizationMode} from '@/model/resource/VisualizationMode'

/* TODO: review generated class */
export class PanelUser extends Resource {
  idPanelUserPk: number = 0
  document: string | null = null
  corporateName: string | null = null
  dueDate: string | null = null
  createdByAdm: boolean | null = null
  creationDate: string | null = null
  active: boolean | null = null
  telephone: string | null = null
  contactName: string | null = null
  email: string | null = null
  lastUpdate: string | null = null
  @ResponseExclude()
  password: string | null = null

  @ResponseSerialize(Address)
  address: Address | null = null

  @ResponseSerialize(UserType)
  userType: UserType | null = null
  @ResponseSerialize(PanelUserInfo)
  panelUserInfo: PanelUserInfo | null = null
  @ResponseSerialize(PanelUserFlags)
  panelUserFlags: PanelUserFlags | null = null

  @ResponseSerialize(VisualizationMode)
  visualizationMode: VisualizationMode | null = null

  get integrationEnabled() {
    if (this.panelUserFlags == null) {
      this.panelUserFlags = new PanelUserFlags()
    }
    return this.panelUserFlags.integrationEnabled
  }

  set integrationEnabled(val: boolean) {
    if (this.panelUserFlags == null) {
      this.panelUserFlags = new PanelUserFlags()
    }
    this.panelUserFlags.integrationEnabled = val
  }

  get hasControlTower() {
    if (this.panelUserFlags == null) {
      this.panelUserFlags = new PanelUserFlags()
    }
    return this.panelUserFlags.hasControlTower
  }

  set hasControlTower(val: boolean) {
    if (this.panelUserFlags == null) {
      this.panelUserFlags = new PanelUserFlags()
    }
    this.panelUserFlags.hasControlTower = val
  }
  reset() {
    this.idPanelUserPk = 0
    this.dueDate = null
  }

  get $id() {
    return this.idPanelUserPk
  }
  set $id(val) {
    this.idPanelUserPk = val
  }
  get $tag() {
    return String(this.$id)
  }

  get idAddressFk() {
    if (!this.address) return 0
    return this.address.$id
  }
  set idAddressFk(val) {
    if (!this.address) this.address = new Address()
    this.address.$id = val
  }

  get idUserTypeFk() {
    if (!this.userType) return 0
    return this.userType.$id
  }
  set idUserTypeFk(val) {
    if (!this.userType) this.userType = new UserType()
    this.userType.$id = val
  }

  get createdBy() {
    return this.createdByAdm
      ? String($.t('schema.ListResponsavel.admin'))
      : String($.t('schema.ListResponsavel.responsavel'))
  }

  static buildNew(): PanelUser {
    const panelUser = new PanelUser()
    panelUser.address = new Address()
    panelUser.idUserTypeFk = UserTypeEnum.SHIPPER
    panelUser.panelUserFlags = new PanelUserFlags()
    panelUser.panelUserInfo = PanelUserInfo.buildNew()
    panelUser.active = true
    return panelUser
  }

  get idVisualizationModeFk() {
    if (!this.visualizationMode) return 0
    return this.visualizationMode.$id
  }
  set idVisualizationModeFk(val) {
    if (!this.visualizationMode)
      this.visualizationMode = new VisualizationMode()
    this.visualizationMode.$id = val
  }

  /**
   * Lists the instances of PanelUser to export as a file
   */
  static async listExportPanelUser(params: any) {
    return await InternationalRequest.get(`/admin/panel-user/export`, {params})
      .name('listExportPanelUser')
      .as(PanelUserCollection)
      .getData()
  }

  /**
   * Lists the instances of PanelUser
   */
  static async listPanelUser(params: any) {
    return await InternationalRequest.get(`/admin/panel-user`, {
      params,
    })
      .name('listPanelUser')
      .as(PanelUserCollection)
      .getData()
  }

  /**
   * Persists a new instance of PanelUser. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistPanelUser() {
    const request = this.$clone()
    request.password = this.password ? sha256(this.password) : null
    return await InternationalRequest.post(`/admin/panel-user`, request)
      .name('persistPanelUser')
      .asNumber()
      .getData()
  }

  /**
   * Gets a instance of a given ID of PanelUser
   */
  async getPanelUser(id: number) {
    return await InternationalRequest.get(`/admin/panel-user/${id}`)
      .name('getPanelUser')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of PanelUser
   */
  async removePanelUser() {
    return await InternationalRequest.delete(`/admin/panel-user/${this.$id}`)
      .name('removePanelUser')
      .asNumber()
      .getData()
  }

  async updateActive(active: boolean) {
    return await InternationalRequest.post(
      `/admin/panel-user/update-active/${this.$id}`,
      {
        active,
      }
    )
      .name('updateAtivo')
      .asNumber()
      .getData()
  }

  /**
   * Update dataValidade in an instance of Responsavel
   */
  async updateDueDate(date: string) {
    return await InternationalRequest.post(
      `/admin/panel-user/update-expired-date/${this.$id}`,
      {dueDate: date}
    )
      .name('updateDataVencimento')
      .asNumber()
      .getData()
  }
}
